import dayjs, { Dayjs } from 'dayjs'

export interface CourseDemoPeriodInfo {
  isDemo: boolean
  isExpired: boolean
  startDate: string | null
  endDate: string | null
  remainingDays: number | null
}

const DEMO_FLAG_FIELDS = ['is_demo', 'isDemo', 'demo_access', 'demoAccess']

const normalizeBoolean = (value: unknown) =>
  value === true || value === 1 || value === '1' || value === 'true'

const parseDate = (value: unknown): Dayjs | null => {
  if (value === null || value === undefined || value === '') return null

  const numericValue = Number(value)
  const parsed =
    Number.isFinite(numericValue) && String(value).trim() !== ''
      ? dayjs(numericValue < 1_000_000_000_000 ? numericValue * 1000 : numericValue)
      : dayjs(value as string)

  return parsed.isValid() ? parsed : null
}

const emptyDemoPeriod: CourseDemoPeriodInfo = {
  isDemo: false,
  isExpired: false,
  startDate: null,
  endDate: null,
  remainingDays: null,
}

export const getCourseDemoPeriodInfo = (
  order: Record<string, any> | null | undefined,
  currentDate: Dayjs = dayjs(),
): CourseDemoPeriodInfo => {
  if (!order) return emptyDemoPeriod

  const explicitFlagField = DEMO_FLAG_FIELDS.find((field) =>
    Object.prototype.hasOwnProperty.call(order, field),
  )
  const explicitDemoFlag = explicitFlagField
    ? normalizeBoolean(order[explicitFlagField])
    : null
  const isMockDemo =
    normalizeBoolean(order?.tariff?.has_demo) &&
    order?.payment_date == null &&
    Boolean(order?.next_payment_date)
  const isDemo = explicitDemoFlag ?? isMockDemo

  if (!isDemo) return emptyDemoPeriod

  const start = parseDate(
    order?.demo_started_at ?? order?.demo_start_at ?? order?.created_at,
  )
  const end = parseDate(
    order?.demo_ends_at ?? order?.demo_end_at ?? order?.next_payment_date,
  )
  const isExpired = end ? end.endOf('day').isBefore(currentDate) : false
  const remainingDays = end && !isExpired
    ? Math.max(Math.ceil(end.endOf('day').diff(currentDate) / 86_400_000), 0)
    : null

  return {
    isDemo: true,
    isExpired,
    startDate: start?.format('DD.MM.YYYY') ?? null,
    endDate: end?.format('DD.MM.YYYY') ?? null,
    remainingDays,
  }
}
